import React from 'react';
import { Box, Button, Skeleton, Typography, useTheme } from '@mui/material';
import { GamifyIcon } from '../../../components/GamifyIcon';
import featureFlag from '../../../common/featureFlag';

export default function ProfileRewardCardsSkeleton() {
  const theme = useTheme();
  return (
    <>
      <Box
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '2ch',
        }}
      >
        {/* <Typography
          style={{ color: '#0B0B0C', fontSize: '16px', fontWeight: 600 }}
        >
          All rewards
        </Typography> */}
        <Box
          style={{
            display: 'flex',
            width: '100%',
            justifyContent: 'flex-start',
          }}
        >
          <Box style={{ width: '33%', marginRight: 16 }}>
            <Typography>Status:</Typography>
            <Box
              sx={{
                width: '100%',
                border: `1px solid ${theme.custom.stroke}`,
                borderRadius: '8px',
                padding: '12px',
              }}
            >
              <Skeleton
                variant={'rounded'}
                sx={{ bgcolor: theme.custom.textLight }}
                width={40}
                height={23}
              ></Skeleton>
            </Box>
          </Box>
          {global.me.isAdmin && (
            <Box style={{ width: '33%' }}>
              <Typography>Person:</Typography>
              <Box
                sx={{
                  width: '100%',
                  border: `1px solid ${theme.custom.stroke}`,
                  borderRadius: '8px',
                  padding: '12px',
                }}
              >
                <Skeleton
                  variant={'rounded'}
                  sx={{ bgcolor: theme.custom.textLight }}
                  width={40}
                  height={23}
                ></Skeleton>
              </Box>
            </Box>
          )}
        </Box>
        {global.me.isAdmin && featureFlag('sendRewards') ? (
          <Button
            sx={{
              '&:hover': {
                backgroundColor: 'white',
              },
            }}
            style={{
              padding: 0,
              minWidth: 140,
            }}
            disableRipple={true}
          >
            <GamifyIcon icon={'send'}></GamifyIcon>
            <Typography
              style={{
                color: '#FF6A00',
                fontSize: '16px',
                fontWeight: 700,
                marginLeft: 7,
              }}
            >
              Send reward
            </Typography>
          </Button>
        ) : (
          <Box></Box>
        )}
      </Box>
      {['', '', '', '', '', ''].map((reward, i) => {
        console.log(reward);
        return <RewardCardSkeleton key={i} theme={theme}></RewardCardSkeleton>;
      })}
    </>
  );
}

function RewardCardSkeleton({ theme }) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: theme.custom.background1,
        padding: '15px',
        border: `1px solid ${theme.custom.stroke}`,
        borderRadius: '8px',
        marginBottom: '12px',
      }}
    >
      <Box className={'rewards-list-item-left-container'}>
        <Skeleton
          variant={'circular'}
          sx={{ bgcolor: theme.custom.textLight, margin: '5px 12px 5px 5px' }}
          width={40}
          height={40}
        ></Skeleton>
        <Box className={'rewards-list-item-left-text-container'}>
          <Skeleton
            variant={'rounded'}
            sx={{
              bgcolor: theme.custom.text,
              marginTop: '2px',
              marginBottom: '2px',
            }}
            width={115}
            height={20}
          ></Skeleton>
          <Skeleton
            variant={'rounded'}
            sx={{
              bgcolor: theme.custom.textLight,
              marginTop: '1px',
              marginBottom: '1px',
            }}
            width={55}
            height={19}
          ></Skeleton>
        </Box>
      </Box>
      <Box
        style={{
          position: 'relative',
          height: 45,
          display: 'flex',
          alignItems: 'flex-start',
        }}
      >
        <Box
          sx={{
            backgroundColor: theme.custom.primaryLight,
            padding: '4px 8px 4px 8px',
            borderRadius: '1000px',
          }}
        >
          <Skeleton
            sx={{
              color: theme.custom.primary,
              marginTop: '1px',
              marginBottom: '1px',
            }}
            width={56}
            height={16}
          ></Skeleton>
        </Box>
      </Box>
    </Box>
  );
}
